import React, { useRef } from "react";
import { languageHelper } from "../../config/helperFunctions";

function Invoice3WithVat({ general, data, invoice, handlePrint, currencySetting, outletData }) {
  const defaultLang =
    invoice.invoice_lang === "default"
      ? localStorage.getItem("rms-lang") || "text_en"
      : invoice.invoice_lang === "Arabic"
      ? "text_ar"
      : "text_en";
  const date = new Date();
  const invoiceRef = useRef(null);

  let day = date.getDate();
  let month = date.getMonth() + 1;
  let year = date.getFullYear();

  // This arrangement can be altered based on how we want the date's format to appear.
  let currentDateSlash = `${month}/${day}/${year}`;

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  let currentTime = `${hours}:${minutes}:${seconds}`;

  // function formatDate(inputDate) {
  //   // Split date and time
  //   const [date] = inputDate.split(" ");
  //   // Split year, month, and day
  //   const [year, month, day] = date.split("-");
  //   // Return formatted date as MM/DD/YYYY
  //   return `${month}/${day}/${year}`;
  // }

  let vatAmount = data.vat_amount - data.tobaco_vat;

  const apiUrl = window.RUNTIME_API_URL;
  const hostname = new URL(apiUrl).hostname;

  const isChangePadding = hostname.includes("sahnew");
  const paddingClass = isChangePadding ? "pr-32" : "pr-16";

  // useEffect(() => {
  //   handlePrint("Default Invoice", invoiceRef);
  // }, [handlePrint]);
  return (
    <>
      {/* for sahnew pr-32 */}
      <div
        ref={invoiceRef}
        className={`flex flex-col justify-center mx-auto w-full my-1 pb-8 pt-2 pl-4 ${paddingClass}`}
      >
        {/* <div ref={invoiceRef} className="w-full max-w-5xl mx-auto py-8 pl-8 pr-8"> */}
        <h1 className="text-xs font-medium text-center mt-6">
          {general.restaurant_name}
        </h1>
        <p className={"text-center text-xs mt-2"}>{invoice?.invoice_tagline}</p>
        <div className="text-center text-xs mt-2">
          <p>{outletData?.address}</p>
          <p>
            {languageHelper("Tel", defaultLang)}: {outletData?.phone}
          </p>
          <p>{languageHelper("Simplified Tax Invoice", defaultLang)}</p>
        </div>
        <p className="mt-2 text-xs text-center">
          {languageHelper("Tax Registration No", defaultLang)}:{" "}
          {general.tax_reg_no}
        </p>

        <p className="text-xs text-center mt-4">
          {languageHelper("Invoice No", defaultLang)}: {data.sale_no}
        </p>
        <div className="mt-4">
          <span className="mx-auto py-1 border-4 text-sm border-black px-2 max-w-64 w-fit text-center block font-bold">
            {languageHelper("Order", defaultLang)} #: {Number(data.token_no)}
            {data.table?.name && (
              <p className="text-xs font-semibold text-center my-2">
                {languageHelper("Table", defaultLang)} #: {data.table?.name}
              </p>
            )}
          </span>
        </div>
        <p className="text-center text-xs mt-2">
          {languageHelper("Printed At", defaultLang)}:{" "}
          {`${currentDateSlash} ${currentTime}`}
        </p>
        <div className="pt-2 border-t-2 border-b-2 border-black text-xs flex gap-4 justify-between">
          <div>
            <p> {data.order_type?.type}</p>
          </div>
          {/* <div className="text-end">
            <p>
              {languageHelper("Check", defaultLang)} #: {data.token_no}
            </p>
            <p>{`${formatDate(data.sale_date)} ${data.order_time}`}</p>
          </div> */}
        </div>
        <div className="text-end border-b text-xs py-1">
          <p>
            {languageHelper("Customer Name", defaultLang)}:{" "}
            {data.is_guest === "no" ? data.customer?.name : data.guest?.name}
          </p>
          {data.order_type_id === 2 && (
            <p>
              {languageHelper("Customer Number", defaultLang)}:{" "}
              {data.is_guest === "no"
                ? data.customer?.phone
                : data.guest?.phone}
            </p>
          )}
          {data?.customer?.customer_vat && (
            <p>
              {languageHelper("Customer Vat", defaultLang)}:{" "}
              {data.is_guest === "no"
                ? data.customer?.customer_vat
                : data.guest?.customer_vat || ""}
            </p>
          )}
        </div>
        <table className="w-full text-xs">
          <thead>
            <tr className="border-b-4 border-black">
              <th className="py-1 text-start">
                {languageHelper("Item", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Qty", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("Item Price", defaultLang)}
              </th>
              <th className="py-1 text-start">
                {languageHelper("VAT", defaultLang)}
              </th>
              <th className="py-1 text-end">
                {languageHelper("Total", defaultLang)}
              </th>
            </tr>
          </thead>
          <tbody>
            {data.order_details?.map((orderItem, index) => (
              <>
                <tr
                  key={index}
                  className={
                    orderItem.modifiers.length === 0 &&
                    `border-b-2 ${
                      data.order_details.length - 1 === index && "border-black"
                    }`
                  }
                >
                  <td>
                    {/* {orderItem.name} / {orderItem.name_arabic} */}
                    {invoice.name_lang === "en" ? (
                      orderItem.name
                    ) : invoice.name_lang === "ar" ? (
                      orderItem.name_arabic
                    ) : (
                      <>
                        <p>{orderItem.name}</p>
                        <p>{orderItem.name_arabic}</p>
                      </>
                    )}
                  </td>
                  <td className="px-0.5">{orderItem.qty}</td>
                  <td className="px-0.5">
                    <p>{orderItem.menu_unit_price.toFixed(2)}</p>
                  </td>
                  <td>
                    {orderItem.menu_taxes.additional_vat_percentage === 100
                      ? `T(${
                          orderItem.menu_taxes.additional_vat_percentage
                        }%) ${
                          Number(orderItem.menu_taxes.vat.toFixed(2)) +
                          Number(orderItem.menu_taxes.additional_vat.toFixed(2))
                        }`
                      : orderItem.menu_taxes.vat_percentage === 15
                      ? `V(${orderItem.menu_taxes.vat_percentage}%) ${
                          Number(orderItem.menu_taxes.vat.toFixed(2)) +
                          Number(orderItem.menu_taxes.additional_vat.toFixed(2))
                        }`
                      : orderItem.menu_taxes.vat_percentage === 0
                      ? `Z(${orderItem.menu_taxes.vat_percentage}%) ${
                          Number(orderItem.menu_taxes.vat.toFixed(2)) +
                          Number(orderItem.menu_taxes.additional_vat.toFixed(2))
                        }`
                      : "Exemption"}
                  </td>
                  <td className="text-end">
                    {orderItem.menu_unit_price_with_vat.toFixed(2) ===
                    orderItem.menu_price_with_discount.toFixed(2) ? (
                      <p>
                        {(
                          orderItem.menu_unit_price_with_vat * orderItem.qty
                        ).toFixed(2)}
                      </p>
                    ) : (
                      <span className="flex gap-2">
                        <p className="line-through">
                          {(
                            orderItem.menu_unit_price_with_vat * orderItem.qty
                          ).toFixed(2)}
                        </p>
                        <p>
                          {(
                            orderItem.menu_price_with_discount * orderItem.qty
                          ).toFixed(2)}
                        </p>
                      </span>
                    )}
                  </td>
                </tr>
                {orderItem.food_menu.is_deal === "yes" && (
                  <tr key={index * -1}>
                    <td colSpan={5}>
                      {orderItem.deal_items &&
                        JSON.parse(orderItem.deal_items)?.map(
                          (deal, index) => (
                            <p key={index}>{`${deal.qty}x ${deal.name}`}</p>
                          )
                        )}
                    </td>
                  </tr>
                )}
                {orderItem.modifiers.map((mod, index) => (
                  <tr
                    key={index * -0.1}
                    className={
                      orderItem.modifiers.length === index + 1 &&
                      `border-b-2 ${
                        data.order_details.length - 1 === index &&
                        "border-black"
                      }`
                    }
                  >
                    <td colSpan={4}>{mod.name}</td>
                    <td className="text-end">
                      {(mod.price * orderItem.qty).toFixed(2)}
                    </td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
          <tbody className="font-medium">
            <tr className="border-b-2">
              <td colSpan={3}>{languageHelper("VAT", defaultLang)}</td>
              <td className="text-end" colSpan={2}>
                {currencySetting.value || "S.R"} {vatAmount.toFixed(2)}
              </td>
            </tr>

            {data.tobaco_vat !== 0 && (
              <tr className="border-b-2">
                <td colSpan={3}>
                  {languageHelper("Tobacco Tax 100%", defaultLang)}
                </td>
                <td className="text-end" colSpan={2}>
                  {currencySetting.value || "S.R"} {data.tobaco_vat}
                </td>
              </tr>
            )}
            <tr className="border-b-2">
              <td colSpan={3}>{languageHelper("Total", defaultLang)}</td>
              <td className="text-end" colSpan={2}>
                {currencySetting.value || "S.R"} {data.total_payable.toFixed(2)}
              </td>
            </tr>

            {data.total_discount_amount !== 0 && (
              <tr className="border-b-2">
                <td colSpan={3}>
                  {languageHelper("Total Discount", defaultLang)}
                </td>
                <td className="text-end" colSpan={2}>
                  {currencySetting.value || "S.R"} {data.total_discount_amount.toFixed(2)}
                </td>
              </tr>
            )}

            {data.delivery_charges !== 0 && (
              <tr className="border-b-2">
                <td colSpan={3}>
                  {languageHelper("Service/Delivery", defaultLang)}
                </td>
                <td className="text-end" colSpan={2}>
                  {currencySetting.value || "S.R"} {data.delivery_charges.toFixed(2)}
                </td>
              </tr>
            )}

            {/* Payment method row after breakdown */}
            <tr className="border-b-2">
              <td colSpan={3}>
                {languageHelper("Payment", defaultLang)} -{" "}
                {data.payment.name === "Multi Cash"
                  ? "Multi Cash"
                  : data.payment.name}
              </td>
              <td className="text-end" colSpan={2}>
                {currencySetting.value || "S.R"} {data.total_payable.toFixed(2)}
              </td>
            </tr>

            {/* Multi Cash breakdown rows */}
            {data.payment.name === "Multi Cash" &&
              data.multiple_payments.map((payment, index) => (
                <tr className="border-b-2" key={index}>
                  <td colSpan={3}>
                    {languageHelper("Payment", defaultLang)} -{" "}
                    {payment.company_name}
                  </td>
                  <td className="text-end" colSpan={2}>
                    {currencySetting.value || "S.R"} {payment.amount.toFixed(2)}
                  </td>
                </tr>
              ))}

            <tr className="border-b-2">
              <td colSpan={3}>
                {languageHelper("Received Amount", defaultLang)}
              </td>
              <td className="text-end" colSpan={2}>
                {currencySetting.value || "S.R"} {(data.received_amount || 0).toFixed(2)}
              </td>
            </tr>

            <tr className="border-b-2">
              <td colSpan={3}>
                {languageHelper("Change Amount", defaultLang)}
              </td>
              <td className="text-end" colSpan={2}>
                {currencySetting.value || "S.R"} {Math.max(data.change_amount || 0, 0).toFixed(2)}
              </td>
            </tr>

            <tr className="text-center border-b-2 border-black">
              <td colSpan={5}>{data.order_details.length}</td>
            </tr>
          </tbody>
        </table>
        <div className="text-xs text-center mt-2">
          <p>{outletData?.phone}</p>
          <img
            src={data.qr_image_base64 || data.qr_image_url}
            className="w-32 mx-auto mt-8 qr-image"
            alt="QR"
          />
        </div>
      </div>
    </>
  );
}

export default Invoice3WithVat;
